import { render } from "./PlatformListToolbar.vue?vue&type=template&id=224c39e7"
import script from "./PlatformListToolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformListToolbar.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/PlatformList/PlatformListToolbar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "224c39e7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('224c39e7', __exports__)) {
    api.reload('224c39e7', __exports__)
  }
  
  module.hot.accept("./PlatformListToolbar.vue?vue&type=template&id=224c39e7", () => {
    api.rerender('224c39e7', render)
  })

}


export default __exports__